import { takeLatest, call, put } from 'redux-saga/effects';
import URLS from '../constants/urls';
import { callApi } from '../utils/api';
import * as EmandateAction from '../actions/eMandateModifyAction';
import * as SnackbarAction from '../actions/snackbarAction';

function* generateMandateOTP(action) {
  try {
    const response = yield call(callApi, URLS.GENERATE_MANDATE_OTP, 'post');
    yield put(EmandateAction.setMandateReferenceId(response.res_data));
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

function* createMandate(action) {
  try {
    yield call(callApi, URLS.CREATE_MANDATE, 'post', action.payload);
    yield put(EmandateAction.setMandateSuccess(true));
  } catch (error) {
    yield put(EmandateAction.setMandateSuccess(false));
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

function* updateMandate(action) {
  try {
    yield call(
      callApi,
      URLS.UPDATE_MANDATE,
      'put',
      action.payload,
      false,
      false,
      false,
      true,
    );
    yield put(EmandateAction.setMandateSuccess(true));
  } catch (error) {
    yield put(EmandateAction.setMandateSuccess(false));
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

function* deleteMandate(action) {
  try {
    yield call(callApi, URLS.DELETE_MANDATE, 'post', action.payload);
    yield put(EmandateAction.setMandateSuccess(true));
  } catch (error) {
    yield put(EmandateAction.setMandateSuccess(false));
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

export function* EMandateModifySaga() {
  yield takeLatest('GENERATE_MANDATE_OTP', generateMandateOTP);
  yield takeLatest('CREATE_MANDATE', createMandate);
  yield takeLatest('UPDATE_MANDATE', updateMandate);
  yield takeLatest('DELETE_MANDATE', deleteMandate);
}
